import settings from '@/settings'

let list = (filtros, headers) => {
  let url = `${settings.apetrusApi}/faturamentos/`

  const filtrosKeys = Object.keys(filtros)

  for (let i = 0; i < filtrosKeys.length; i++) {
    if (i === 0) {
      url = `${url}?${filtrosKeys[i]}=${filtros[filtrosKeys[i]]}`
    } else {
      url = `${url}&${filtrosKeys[i]}=${filtros[filtrosKeys[i]]}`
    }
  }

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let info = (id, headers) => {
  return fetch(`${settings.apetrusApi}/faturamentos/${id}/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let dadosFaturamento = (id, headers) => {
  return fetch(`${settings.apetrusApi}/faturamentos/dadosfatura/${id}/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let createCobranca = (data, headers) => {
  return fetch(`${settings.apetrusApi}/faturamentos/cobrancas/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let updateCobranca = (id, data, headers) => {
  return fetch(`${settings.apetrusApi}/faturamentos/cobrancas/${id}/`, {
    method: 'PATCH',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let update = (id, data, headers) => {
  return fetch(`${settings.apetrusApi}/faturamentos/${id}/`, {
    method: 'PATCH',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let gerarFaturamento = (data, headers) => {
  return fetch(`${settings.apetrusApi}/faturamentos/gerarfaturamento/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

const gerenciar = (headers, data) => {
  let url = `${settings.apetrusApi}/faturamentos/faturas/`
  const parameters = {
    method: data.method,
    mode: 'cors',
    headers: headers
  }
  if (data.parametros) {
    Object.keys(data.parametros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${data.parametros[filter]}`
    })
  }
  if (data.method === 'GET') {
    parameters.cache = 'default'
  } else parameters.body = JSON.stringify(data.corpo)
  return fetch(url, parameters)
}

export default {
  list,
  info,
  createCobranca,
  updateCobranca,
  update,
  gerarFaturamento,
  dadosFaturamento,
  gerenciar
}
